export default __webpack_public_path__ + "static/media/activtyHistory.39734635.svg";